import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import toast from "../../helpers/toast";
import Httpconfig from "../helpers/HttpconfigAdmin";
import Constant from "../../constants";
import { Link } from "react-router-dom";

export default class createCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {},
      errors: {},
      controller_data: "",
      originalControllerData: "", // Store original data for search
      pageHeading: "",
      search: "",
      searchInput: "input-group col-md-8"
    };
  }

  // To get detais after first render
  componentDidMount = () => {
    const { handle } = this.props.match.params;
    handle ? this.state.pageHeading = "Update Category" : this.state.pageHeading = "create Category"
    this.getControllerInfo();
  };

  // fetches all controllers
  getControllerInfo() {
    Httpconfig.httptokenget(Constant.siteurl + "api/CategoryType/").then(
      (response) => {
        this.setState({
          controller_data: response.data,
          originalControllerData: response.data, // Store original data
        });
      }
    );
  }

  // Search functionality for category types using API
  searchCategoryType = (event) => {
    let searchString = event.target.value;
    this.setState({ search: searchString });

    if (searchString !== "") {
      // Make API call to search category types
      console.log("Searching category types with:", searchString);
      Httpconfig.httptokenpost(
        Constant.siteurl + "api/CategoryType/search",
        {
          search_type: "category_type_search",
          category_type: searchString,
        }
      ).then((response) => {
        console.log("Category type search response:", response);
        if (response.status === 200 && response.data && response.data.data) {
          this.setState({ controller_data: response.data.data });
        } else {
          this.setState({ controller_data: [] });
        }
      }).catch((error) => {
        console.log("Category type search API error:", error);
        // Fallback to local search if API fails
        console.log("Using fallback local search");
        const filteredData = this.state.originalControllerData.filter((item) =>
          item.category_type.toLowerCase().includes(searchString.toLowerCase())
        );
        this.setState({ controller_data: filteredData });
      });
    } else {
      // Reset to original data when search is empty
      this.setState({ controller_data: this.state.originalControllerData });
    }
  };

  // When value changes of the fields
  handleChange = (field, event) => {
    let fields = this.state.fields;
    fields[field] = event.target.value;
    this.setState({ fields });
  };

  // To get all the ResponderInfo
  getSpecialitiesInfo(handle) {
    Httpconfig.httptokenget(Constant.siteurl + "api/specialities/" + handle)
      .then((response) => {
        this.setState({
          fields: {
            speciality_name: response.data.data[0].speciality_name,
            id: response.data.data[0].category_id,
          },
        });
      })
      .catch((error) => { });
  }

  // create or update
  checkSubmit(event) {
    event.preventDefault();
    const { handle } = this.props.match.params;
    if (this.handleValidation() && handle) {
      this.updateSpecialities(event);
    } else if (this.handleValidation() && handle == undefined) {
      this.createSpecialities(event);
    } else {
      toast.warn("Form has errors.");
    }
  }

  // creates new controller
  createSpecialities = (event) => {
    event.preventDefault();
    const { fields, errors } = this.state;
    Httpconfig.httptokenpost(Constant.siteurl + "api/specialities/create", {
      speciality_name: fields["speciality_name"],
      category_id: fields["id"],
    })
      .then((response) => {
        toast.success("Successfully Created Speciality");
        setTimeout(
          () => this.props.history.push("/admin/Viewspecialities"),
          2000
        );
      })
      .catch((error) => { });
  };

  // updates controller
  updateSpecialities = (event) => {
    event.preventDefault();
    const { handle } = this.props.match.params;
    const { fields, errors } = this.state;
    Httpconfig.httptokenput(Constant.siteurl + "api/specialities/" + handle, {
      speciality_name: fields["speciality_name"],
      category_id: fields["id"],
    })
      .then((response) => {
        toast.success("Successfully Updated Speciality");
        setTimeout(
          () => this.props.history.push("/admin/Viewspecialities"),
          2000
        );
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  handleValidation() {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;

    if (!fields["speciality_name"]) {
      formIsValid = false;
      errors["speciality_name"] = "Speciality name cannot be empty";
    }
    if (!fields["id"]) {
      formIsValid = false;
      errors["id"] = "Category name cannot be empty";
    }
    this.setState({ errors: errors });
    return formIsValid;
  }

  render() {
    const { fields, errors, controller_data } = this.state;
    return (
      <section id="main_dashboard">
        <div className="container" id="main_front">
          <div className="row">
            <div className="col-md-12">
              <div className="dash-section">
                <div className="section-header">
                  <ol className="breadcrumb">
                    <li className="active">
                      <Link to="/admin"> Dashboard</Link> &gt;
                      <a> Specialities </a>
                    </li>
                  </ol>
                </div>
              </div>

              <section id="CMS_tab">
                <div className="CMS_content">
                  <div className="container">
                    <div className="row">
                      <div className="tab-header">
                        <h3>{this.state.pageHeading}</h3>
                      </div>
                      
                      {/* Search functionality */}
                      <div className="manage_search">
                        <div className={this.state.searchInput} id="search_input">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search category type by name"
                            value={this.state.search}
                            onKeyUp={this.searchCategoryType}
                            onChange={this.searchCategoryType}
                          />
                          <div className="input-group-btn">
                            <div className="btn-group" role="group">
                              <button 
                                type="button" 
                                className="btn btn-default"
                                onClick={this.searchCategoryType}
                              >
                                <i className="fa fa-search"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div id="reg_form">
                        <form onSubmit={this.checkSubmit.bind(this)}>
                          <div className="row">
                            <div className="col-md-4">
                              <div className="form-group col-md-12">
                                <select
                                  name="category_id"
                                  className="form-control"
                                  value={this.state.fields["id"] || ""}
                                  onChange={this.handleChange.bind(this, "id")}
                                >
                                  <option value="">Select Category Type</option>
                                  {controller_data &&
                                    controller_data.map(
                                      (controller_data, i) => {
                                        return (
                                          <option key={i} value={controller_data.id}>
                                            {controller_data.category_type}
                                          </option>
                                        );
                                      }
                                    )}
                                </select>
                                <span className="cRed">
                                  {this.state.errors["id"]}
                                </span>
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group col-md-12">
                                <input
                                  type="ftext"
                                  name="speciality_name"
                                  className="form-control"
                                  value={
                                    this.state.fields["speciality_name"] || ""
                                  }
                                  onChange={this.handleChange.bind(
                                    this,
                                    "speciality_name"
                                  )}
                                  placeholder="Category Name"
                                />
                                <span className="cRed">
                                  {this.state.errors["speciality_name"]}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="form-group col-md-8">
                              <button
                                type="submit"
                                className="btn  btn-primary padTopCategorySave fright"
                              >
                                Save Cateogry
                              </button>{" "}
                              &nbsp;
                              <Link
                                to="/admin/Viewcategory"
                                className="padTopCategorySave hrefCategory fright"
                              >
                                Cancel
                              </Link>{" "}
                              &nbsp; &nbsp;
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <ToastContainer />
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
